(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click',async event=>{
 const button=event.target.closest('[data-bis-cookie-settings]');
 if(!button)return;
 const error=button.parentElement.querySelector('[data-bis-cookie-error]');
 error.hidden=true;
 button.disabled=true;
 try{
  if(!window.privacyBanner?.showPreferences)throw new Error('Banner unavailable');
  await window.privacyBanner.showPreferences();
 }catch(e){error.hidden=false}
 finally{button.disabled=false}
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
